import { memo } from 'react';

import { NoWorkspaceContentState } from '~/components/AllContent/NoWorkspaceContentState';

export const DefaultNoWorkspaceContentState = memo(() => (
  <NoWorkspaceContentState
    title="Add content to this workspace"
    description="Upload from your computer via drag-and-drop, or click the button below"
  />
));

DefaultNoWorkspaceContentState.displayName = 'DefaultNoWorkspaceContentState';
